import styled from 'styled-components';

export const AlignCenter = styled.div`
  text-align: center;
`;
